import styled from "styled-components";
import { motion } from "framer-motion";
import { fontMixin } from "../../../styles";

export const Tooltip_Content = styled(motion.div)`
	position: fixed;
	z-index: 999999;
	width: max-content;
	max-width: 320px;
	padding: 8px 10px;
	border-radius: 8px;
	background: rgba(24, 24, 24, 0.94);
	backdrop-filter: blur(10px);
	color: #ffffff;
	${fontMixin({ size: 12, weight: 400 })};
	line-height: 16px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);
	pointer-events: none;
	transform: translateY(-100%);
`;

export const Tooltip_Wrapper = styled(motion.div)`
	width: 100%;
	min-width: 0;
`;
